import React, { useEffect, useState } from "react";
import moment from "moment";
import Scrollspy from "react-scrollspy";
import DBComponent from "../../../components/VendorComponents/DashBoard/DBComponent";
import "../../../assets/scss/vendor_scss/dashboard.scss";
import defaultAppIcon from "../../../assets/images/defaultAppIcon.svg";
import dbMailIcon from "../../../assets/images/db_mail_icon.svg";
import dbPhoneIcon from "../../../assets/images/db_phone_icon.svg";
import { calanderDateFormater } from "../../../components/utils/dateCalculater";
import VendorCalander from "../../../components/VendorComponents/DashBoard/VendorCalander";
import { DateType } from "../../../components/VendorComponents/DashBoard/utlits";
import { DownloadReportsTypes, isDacimal } from "./DBCosntants";
import {
  downloadReports,
  vendorDashboard,
} from "../../../services/MyApps/myAppServise";
import ErrorMsg from "../../../components/CommonCompnents/ErrorMsg";
import { accRedircet } from "../../../services/genralServise";
import {
  constants,
  errorsMsg,
  getTolocalStorage,
  removeServerErrors,
} from "../../Constants/commenFeatures";
import socialLinks from "../../../config/socialsLinks";

export interface IDeshboardProps {}

const Dashboard: React.FC<IDeshboardProps> = () => {
  const [isCalander, setIsCalander] = useState<boolean>(false);
  const [dbData, setDBData] = useState<any>();
  const [date, setDate] = useState<DateType>({
    frmDt: new Date(),
    toDt: new Date(),
  });

  const [appName, setAppName] = useState<string>(getTolocalStorage("appNm"));

  const [isServerErr, setIsServerErr] = useState({
    successRes: "",
    failedRes: "",
    limitExceeded: "",
  });

  const hendelSetDates = (frmDt: Date, toDt: Date) => {
    setDate({
      frmDt: frmDt,
      toDt: toDt,
    });
    setIsCalander(false);
  };

  const removeIsServerErrors = () => {
    setIsServerErr({
      successRes: "",
      failedRes: "",
      limitExceeded: "",
    });
  };

  const downloadDbReportsRes = (res: any) => {
    if (res && res.data) {
      accRedircet(res.data.url);
    } else if (res && res.error) {
      setIsServerErr({
        successRes: "",
        failedRes: res.error.errMsg || errorsMsg.commonError,
        limitExceeded: "",
      });
    }
    removeServerErrors(removeIsServerErrors, constants.ErrorTimeout);
  };

  const downloadDbReports = async (rpTyp: string) => {
    const url = {
      frmDt: moment(date.frmDt).format("yyyy-MM-DD"),
      toDt: moment(date.toDt).format("yyyy-MM-DD"),
      apiKey: await getTolocalStorage("apiKey"),
      rpTyp,
    };
    downloadReports(downloadDbReportsRes, url);
  };

  const getDBDataRes = (res: any) => {
    if (res && res.data) {
      setDBData(res.data);
      if (res.data.ros !== "") {
        setIsServerErr({
          successRes: "",
          failedRes: res.data.ros || errorsMsg.commonError,
          limitExceeded: "",
        });
      }
    } else if (res && res.error) {
      setIsServerErr({
        successRes: "",
        failedRes: res.error.errMsg || errorsMsg.commonError,
        limitExceeded: "",
      });
    }
  };

  const getDBData = async () => {
    setIsServerErr({
      successRes: "",
      failedRes: "",
      limitExceeded: "",
    });
    setDBData("");
    const url = {
      userId: await getTolocalStorage("ldID"),
      frmDt: moment(date.frmDt).format("yyyy-MM-DD"),
      toDt: moment(date.toDt).format("yyyy-MM-DD"),
    };
    vendorDashboard(getDBDataRes, url);
  };

  useEffect(() => {
    getDBData();
  }, [date]);

  return (
    <div>
      <div className="dashboard_container">
        <div className="dashboard_fixed">
          {/* DashBoard Header Start */}
          <div className="dashboard_header">
            <div className="left_header">
              <img src={defaultAppIcon} alt="defaultAppIcon" />
              <h3>{appName}</h3>
            </div>
            <div className="right_header">
              <p className="pointer" onClick={() => setIsCalander(!isCalander)}>
                <span className="edel-icon-calendar"></span>{" "}
                {calanderDateFormater(date.frmDt)} -{" "}
                {calanderDateFormater(date.toDt)}
              </p>
              <VendorCalander
                isCalander={isCalander}
                setDate={hendelSetDates}
                date={date}
                setIsCalander={setIsCalander}
              />

              <p>
                <span
                  className="pointer"
                  onClick={() => downloadDbReports(DownloadReportsTypes.All)}
                >
                  <i className="edel-icon-download"></i> Download
                </span>
              </p>
            </div>
          </div>
          {/* DashBoard Header End */}
          <ErrorMsg isServerErr={isServerErr} />
          {/* User Activity Data Start */}
          <div className="dashboard_activity mb-20">
            <div className="activity_one">
              <div className="hc_col">
                <p>Total Clients Logins</p>
                <h3>{dbData ? isDacimal(dbData.ntClntLgn) : 0}</h3>
                <p>Unique Clients Logins</p>
                <h3>
                  {dbData ? isDacimal(dbData.unqClntLgn) : 0}{" "}
                  <span>({dbData ? dbData.unqClntLgnPr : "0%"})</span>
                </h3>
              </div>
              <div className="vc_col">
                <p>Accepted Consent</p>
                <h4>{dbData ? isDacimal(dbData.clntAcptCnsnt) : 0}</h4>
                <p>Denied Consent</p>
                <h4>{dbData ? isDacimal(dbData.clntDecCnsnt) : 0}</h4>
              </div>
            </div>
            <div className="activity_one">
              <div className="hc_col">
                <p>Unique Client Ordered</p>
                <h3>{dbData ? isDacimal(dbData.unqClntOrd) : 0}</h3>
                <p>Unique Clients Traded</p>
                <h3>
                  {dbData ? isDacimal(dbData.unqClntTrd) : 0}{" "}
                  <span>({dbData ? dbData.unqClnTrdPr : "0%"})</span>
                </h3>
              </div>
            </div>
            <div className="activity_one">
              <div className="hc_col">
                <p>Total Orders Placed</p>
                <h3>{dbData ? isDacimal(dbData.ntOrd) : 0}</h3>
                <p>Total Orders Executed</p>
                <h3>
                  {dbData ? isDacimal(dbData.ntTrds) : 0}{" "}
                  <span>({dbData ? dbData.ordTrdConvPr : "0%"})</span>
                </h3>
              </div>
              <div className="vc_col">
                <p>Total Trades</p>
                <h4>{dbData ? isDacimal(dbData.ntFlTrds) : 0}</h4>
              </div>
            </div>
            {/* <div className="earning_activity">
              <p>My Earnings</p>
              <h2>
                <span className="rupee_symbol">₹</span> 1.9 Cr
              </h2>
            </div> */}
          </div>

          <div>
            <Scrollspy
              className="dashboard_menu "
              items={[
                "Login-vs-trading",
                "volume-statistics",
                "other-statistics",
              ]}
              currentClassName="active"
              componentTag={"div"}
              offset={-130}
            >
              {/* <div>
              <p>My Earnings</p>
            </div> */}
              <div>
                <a href="#Login-vs-trading">Login Vs Trading Statistics</a>
              </div>
              <div>
                <a href="#volume-statistics">Volume Statistics</a>
              </div>
              <div>
                <a href="#other-statistics">Other Statistics</a>
              </div>
            </Scrollspy>
          </div>
        </div>
      </div>
      <div className="chart_container">
        <DBComponent dbData={dbData} downloadDbReports={downloadDbReports} />
      </div>

      <div className="DB_footer">
        <div className="DB_footer_contant">
          <h4>Get in touch</h4>
          <div className="contants">
            <img src={dbMailIcon} alt={dbMailIcon} />
            <a href={`mailto:${socialLinks.supportEmail}`}>
              <p>{socialLinks.supportEmail}</p>
            </a>
          </div>
          <div>
            <img src={dbPhoneIcon} alt={dbPhoneIcon} />
            <p>022 -122345567</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
